
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.8889 7.1665H4.11111C3.49746 7.1665 3 7.64135 3 8.22711V11.9392C3 12.525 3.49746 12.9998 4.11111 12.9998H11.8889C12.5025 12.9998 13 12.525 13 11.9392V8.22711C13 7.64135 12.5025 7.1665 11.8889 7.1665Z","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.5 7.16667L5.5 5.45115C5.5 4.80106 5.76339 4.1776 6.23223 3.71792C6.70107 3.25825 7.33696 3 8 3C8.66304 3 9.29893 3.25825 9.76777 3.71792C10.2366 4.1776 10.5 4.80106 10.5 5.45115V7.16667","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    